/**
 * Feature flags configuration
 */

export interface FeatureFlags {
  /** Use new expandable legend structure instead of filter-based approach */
  USE_EXPANDABLE_LEGEND: boolean;
  
  /** Fallback to old logic if expandable legend fails */
  EXPANDABLE_LEGEND_FALLBACK: boolean;
  
  /** Enable debug logging for expandable legend */
  EXPANDABLE_LEGEND_DEBUG: boolean;
}

export const FEATURE_FLAGS: FeatureFlags = {
  // Default to true - backend now provides expandable legend data
  USE_EXPANDABLE_LEGEND: process.env.REACT_APP_USE_EXPANDABLE_LEGEND !== 'false',
  EXPANDABLE_LEGEND_FALLBACK: process.env.REACT_APP_EXPANDABLE_LEGEND_FALLBACK !== 'false',
  EXPANDABLE_LEGEND_DEBUG: process.env.REACT_APP_EXPANDABLE_LEGEND_DEBUG === 'true',
};

/**
 * Check if expandable legend feature is enabled
 */
export function isExpandableLegendEnabled(): boolean {
  return FEATURE_FLAGS.USE_EXPANDABLE_LEGEND;
}

/**
 * Check if fallback to old logic is enabled
 */
export function shouldFallbackToFilters(): boolean {
  return FEATURE_FLAGS.EXPANDABLE_LEGEND_FALLBACK;
}

/**
 * Check if debug logging is enabled
 */
export function isExpandableLegendDebugEnabled(): boolean {
  return FEATURE_FLAGS.EXPANDABLE_LEGEND_DEBUG;
}